module.exports = __webpack_public_path__ + "img/user.36ef627a.svg";